import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Bitke",
  "description": "",
  "published": "2007-05-15T00:00:00.000Z",
  "redirect_from": ["/blog/bitke/swizec/212"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`VÄeraj se bila je huda bitka. Ljudje so trpeli in ljudje so umirali in predvsem je bilo veliko eksplozij. MoÅ¾narji so bruhali in bombe so padale. Pokrajina je za vedno spremenjena v morje kraterjev in odtrganih udov. Vasi ne bodo nikoli veÄ iste, njihovi moški so mrtvi, njihove Å¾ene izropane in hiše posiljene. Ljudstvo je moÄ‡no trpelo, ko so vdirajoÄe vojske ropale po podeÅ¾elju in so ubogi pridelki umirali na tone.`}</p>
    <p>{`Rezultat? Dobil sem pozitivno pri nemšÄini.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      